import { useHistory, useParams } from "react-router-dom";
import {
  dateStringToTimeAgo,
  dateToTimeAgoFormats,
} from "@circle-react/helpers/dateTimeHelpers/timeAgo";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-shared/uikit/Typography";
import ConversationStatusPill from "./ConversationStatusPill";

export interface Conversation {
  conversation_created_at: string;
  id: string;
  is_circle_bot: boolean;
  is_email: boolean;
  is_live_chat: boolean;
  state_transition: string[];
  status: "draft" | "closed" | "solved" | "open";
  title: string;
}

const ConversationItem = ({ conversation }: { conversation: Conversation }) => {
  const history = useHistory();
  const { id: selectedId } = useParams<{ id: string }>();
  const isSelected = String(selectedId) === String(conversation.id);

  const formattedDate = conversation.conversation_created_at
    ? dateStringToTimeAgo(conversation.conversation_created_at, {
        format: dateToTimeAgoFormats.short,
      })
    : "";

  const handleClick = () => {
    history.push(`/conversations/${conversation.id}`);
  };

  return (
    <button
      className={classNames(
        "hover:bg-tertiary line-clamp-2 w-full rounded-lg p-2 text-left transition-colors duration-200",
        {
          "bg-tertiary": isSelected,
        },
      )}
      onClick={handleClick}
      type="button"
    >
      <div className="flex flex-col py-[3px]">
        <div className="flex justify-between">
          <Typography.LabelSm color="text-primary" weight="medium">
            {conversation.title}
          </Typography.LabelSm>
          <ConversationStatusPill status={conversation.status} />
        </div>
        <div className="flex items-center gap-2 truncate">
          <Typography.LabelSm color="text-tertiary" weight="medium">
            {conversation.state_transition.join(" → ")}
          </Typography.LabelSm>
          <div className="h-1 w-1 rounded-full bg-[#D9D9D9]" />
          <Typography.LabelSm color="text-tertiary" weight="medium">
            {formattedDate}
          </Typography.LabelSm>
        </div>
      </div>
    </button>
  );
};

export default ConversationItem;
